import getRoomListsJsonRequest from 'owa-service/lib/factory/getRoomListsJsonRequest';
import type GetRoomListsJsonResponse from 'owa-service/lib/contract/GetRoomListsJsonResponse';
import getRoomListsOperation from 'owa-service/lib/operation/getRoomListsOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Calls getRoomListsOperation to get Room Lists
 */
export default function getRoomListsService(): Promise<GetRoomListsJsonResponse> {
    return getRoomListsOperation(
        getRoomListsJsonRequest({
            Header: getJsonRequestHeader(),
            Body: {},
        })
    );
}
